var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refund-page"},[_c('van-empty',{attrs:{"description":"官方频道暂未开放~"}}),_c('p',{staticClass:"intro"},[_vm._v("敬请期待")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }